// extracted by mini-css-extract-plugin
export default {"attachments-section":"ChatAttachments_attachments-section__SAcMN","compact-attachments":"ChatAttachments_compact-attachments__JyN+d"};